import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FORMS_HOME_PREVIEW_LIMIT } from './formsHomeHelpers';
import ApproveForms from '../ApproveForms/ApproveForms';

export default function FormsHomeApproveSection({ onCardColumnClick, history }) {
  const [approvalData, setApprovalData] = useState([]);
  return (
    <section className="forms-home-section">
      <div className="forms-home-section-header">
        <div>
          <h2 className="forms-home-section-title">Needs your approval</h2>
          <p className="forms-home-section-subtitle">
            {approvalData.length} forms pending — showing the {Math.min(FORMS_HOME_PREVIEW_LIMIT, approvalData.length)} oldest
          </p>
        </div>
        <span
          className="forms-home-view-all"
          onClick={() => history.push('/forms/approve')}
        >
          View all →
        </span>
      </div>
      <ApproveForms
        onCardColumnClick={onCardColumnClick}
        hideHeader
        dataLimit={FORMS_HOME_PREVIEW_LIMIT}
        setApprovalData={setApprovalData}
      />
    </section>
  );
}

FormsHomeApproveSection.propTypes = {
  onCardColumnClick: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
